'use strict';
module.exports = ['translateFilter'
    , function (translateFilter) {
        var service = {};

        /**
         * Risultati modali
         */
        service.modalResults = {
            cancel: 'CANCEL',
            saveSuccess: 'SAVE_SUCCESS',
            saveError: 'SAVE_ERROR'
        };
        return service;
    }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/utilsService.js
// module id = 259
// module chunks = 0